Namespace('Settings.Views.ChatbotConfiguration')

class Settings.Views.ChatbotConfiguration.IntentsTableDescriptionPlaceholderView extends Backbone.View
  className: 'intents-table-description-placeholder'

  render: =>
    @
